module.exports = __webpack_public_path__ + "img/group1.9d65a7b5.png";